import { render, staticRenderFns } from "./approved-leads.vue?vue&type=template&id=0b98f44e"
import script from "./approved-leads.vue?vue&type=script&lang=js"
export * from "./approved-leads.vue?vue&type=script&lang=js"
import style0 from "./approved-leads.vue?vue&type=style&index=0&id=0b98f44e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports